import { GuestCategoryDisplayTypeEnum } from '@app/enums';
import { GuestCategory, GuestCategoryEnum } from '@app/models/api/api-types';
import { RatingCategoryModel } from '@app/models/elastic-search/';

export interface GuestCategoryDisplayInfo {
    type: GuestCategoryDisplayTypeEnum;
    translationKey: string;
}

const GUEST_CATEGORY_TO_DISPLAY_INFO: Record<GuestCategoryEnum, GuestCategoryDisplayInfo | null> = {
    [GuestCategoryEnum.Colleagues]: {
        type: GuestCategoryDisplayTypeEnum.Business,
        translationKey: 'business',
    },
    [GuestCategoryEnum.IndividualTraveller]: {
        type: GuestCategoryDisplayTypeEnum.Solo,
        translationKey: 'solo',
    },
    [GuestCategoryEnum.YoungCouple]: {
        type: GuestCategoryDisplayTypeEnum.Couple,
        translationKey: 'couple',
    },
    [GuestCategoryEnum.OlderCouple]: {
        type: GuestCategoryDisplayTypeEnum.Couple,
        translationKey: 'couple',
    },
    [GuestCategoryEnum.MiddleAgedCouple]: {
        type: GuestCategoryDisplayTypeEnum.Couple,
        translationKey: 'couple',
    },
    [GuestCategoryEnum.FamilyWithOlderChildren]: {
        type: GuestCategoryDisplayTypeEnum.Family,
        translationKey: 'family',
    },
    [GuestCategoryEnum.FamilyWithSmallChild]: {
        type: GuestCategoryDisplayTypeEnum.Family,
        translationKey: 'family',
    },
    [GuestCategoryEnum.GroupOfFriends]: {
        type: GuestCategoryDisplayTypeEnum.Friends,
        translationKey: 'friends',
    },
    [GuestCategoryEnum.Group]: {
        type: GuestCategoryDisplayTypeEnum.Friends,
        translationKey: 'friends',
    },
    [GuestCategoryEnum.Unknown]: null,
    [GuestCategoryEnum.Other]: null,
};

/**
 * Maps guest category to display information including type and translation key
 * @param category - Guest category from the review (can be string, GuestCategory object, or RatingCategoryModel object)
 * @returns Display information or null if category should not be displayed
 */
export const getGuestCategoryDisplayInfo = (
    category?: string | GuestCategory | RatingCategoryModel | null,
): GuestCategoryDisplayInfo | null => {
    if (!category) {
        return null;
    }

    let categoryType: string;
    if (typeof category === 'string') {
        categoryType = category;
    } else if (typeof category === 'object' && 'type' in category) {
        categoryType = category.type;
    } else {
        return null;
    }

    return GUEST_CATEGORY_TO_DISPLAY_INFO[categoryType as GuestCategoryEnum] || null;
};
